export { default } from './Alignment';
